module.exports = __webpack_public_path__ + "img/sign_position_handler.dc127ae2.png";